import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { storeIdAction } from "../../../redux/actions/general-action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  salesInvoiceEditAction,
  salesInvoiceReceiptCreateAction,
} from "../../../redux/actions/sales-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import SalesPurchaseFooter from "../sales-purchase-footer";
import SalesPurchaseNavbar from "../sales-purchase-navbar";
import SalesItemsSection from "../sales-items-sec";
import SalesBatchesPanel from "../sales-batches-panel";

// Rolls the per-row values up into the header totals the footer renders.
// The clone flow builds its rows straight from `clone_batch_details` (see
// buildBatchesFromCloneDetails below) and therefore skips the per-row stock
// lookup that normally writes these header fields — without this the footer
// would sit at 0 even though every row carries an amount.
const rollUpFooterTotals = (rows = [], header = {}) => {
  const baseTotal = rows.reduce(
    (sum, row) => sum + (parseFloat(row?.item_total_amount) || 0),
    0
  );
  const totalTax = rows.reduce(
    (sum, row) => sum + (parseFloat(row?.item_tax_amount) || 0),
    0
  );
  const totalDiscount = rows.reduce(
    (sum, row) => sum + (parseFloat(row?.item_discount_amount) || 0),
    0
  );

  // TCS/TDS and the invoice adjustment are carried over from the source
  // document, so apply them on top of the freshly summed row amounts the
  // same way the footer does when the user edits them.
  const tcsTdsType = header?.tds_tcs_type;
  const tcsTdsPercentage = parseFloat(header?.tcs_or_tds_percentage) || 0;
  let tcsTdsAmount = 0;
  let totalWithTcsTds = baseTotal;
  if (tcsTdsType === "tcs") {
    tcsTdsAmount = (baseTotal * tcsTdsPercentage) / 100;
    totalWithTcsTds = baseTotal + tcsTdsAmount;
  } else if (tcsTdsType === "tds") {
    tcsTdsAmount = ((baseTotal - totalTax) * tcsTdsPercentage) / 100;
    totalWithTcsTds = baseTotal - tcsTdsAmount;
  }

  const isInvDisPercentage = header?.is_invoice_dis_percentage ?? true;
  const headerInvDis = parseFloat(header?.header_inv_dis_per) || 0;
  const invoiceDiscount = isInvDisPercentage
    ? (totalWithTcsTds * headerInvDis) / 100
    : headerInvDis;
  const invoiceDiscountPercentage = isInvDisPercentage
    ? headerInvDis
    : totalWithTcsTds > 0
    ? (headerInvDis / totalWithTcsTds) * 100
    : 0;

  const totalAfterInvDiscount = totalWithTcsTds - invoiceDiscount;
  const roundedTotal = Math.round(totalAfterInvDiscount);

  return {
    sub_total: (baseTotal - totalTax + totalDiscount).toFixed(2),
    total_gst: totalTax.toFixed(2),
    total_discount: totalDiscount.toFixed(2),
    tcs_or_tds_amount: tcsTdsAmount.toFixed(2),
    tcs_or_tds_percentage: tcsTdsPercentage,
    invoice_discount: invoiceDiscount.toFixed(2),
    invoice_discount_percentage: invoiceDiscountPercentage,
    total_amount: roundedTotal.toFixed(2),
    round_off_value: (roundedTotal - totalAfterInvDiscount).toFixed(2),
  };
};
const CreateEditViewSalesInv = ({
  isClone = false,
  orderDetail = [],
  vendorDetails = [],
  type = "",
  page = "",
  disabled = false,
  data,
  standAlone = false,
  itemData,
  payto,
  shipto,
  pageType,
  clickedplus,
  auto = false,
  isNotViewOnly = true,
  transfer=false,
  itemsLoading = false,
  onItemsScroll,
}) => {
  const [heading, setHeading] = useState([]);

  const [buttonLoading, setButtonLoading] = useState(false);
  const isDispatchingRef = useRef(false);
  const submitScheduledRef = useRef(false);
  const searchRef = useRef(null);
  const [tcsTdsAmount, setTcsTdsAmount] = useState("");

  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const initialData = {
    sl_no: 1,
    item_code: "",
    item_generic_name: "",
    item_name: "",
    item_hsn: "",
    item_manufacturer_name: "",
    item_uom: "",
    item_to_be_delivered: 0,
    quantity: 0,
    item_free_quantity: 0,
    item_batches: [],
    item_discount_amount: 0.0,
    item_total_tax_percentage: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    instock: true,
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_igst: 0,
    item_uom_id: "",
    item_manufacturer_id: "",
    pot_id: null,
    pos_id: null,
    base_quantity: 1,
    base_ref_id: null,
    base_ref_type: null,
    base_ref_line_id: null,
    base_ref_doc_number: null,
  };

  const isInterState =
    vendorDetails?.[0]?.gst_type === "Inter"
      ? true
      : vendorDetails?.[0]?.gst_type === "Intra"
      ? false
      : null;

  const findRowUom = (item) => {
    const uomName = String(item?.item_uom ?? "").trim().toLowerCase();
    return item?.uom_dropdown?.find(
      (uom) =>
        (item?.item_uom_id && uom?.item_id === item?.item_uom_id) ||
        (uomName &&
          String(uom?.alt_uom ?? "").trim().toLowerCase() === uomName)
    );
  };

  const getCloneRowBaseQuantity = (item) =>
    parseFloat(findRowUom(item)?.base_quantity) ||
    parseFloat(item?.base_quantity) ||
    1;

  const buildBatchesFromCloneDetails = (cloneDetails, item) => {
    const itemDetails = cloneDetails?.itemDetails ?? [];
    // Same reference rates handleQuantityChange uses: percentages come from the
    // first itemDetails entry and apply to every allocated batch.
    const taxPct = parseFloat(itemDetails?.[0]?.item_total_tax_percentage) || 0;
    const cgstPct =
      parseFloat(itemDetails?.[0]?.item_batch_cgst_percentage) || 0;
    const sgstPct =
      parseFloat(itemDetails?.[0]?.item_batch_sgst_percentage) || 0;
    const igstPct =
      parseFloat(itemDetails?.[0]?.item_batch_igst_percentage) || 0;
    const rowBaseQty = getCloneRowBaseQuantity(item);

    return itemDetails.map((d) => {
      // Scale the per-base-unit selling/unit price by the UOM base quantity —
      // don't take item_selling_price as the rate for one entered unit. The
      // row's own UOM is authoritative here: the clone endpoint takes no
      // base_quantity param and reports item_uom_base_quantity as 1, so
      // trusting that field would price a "Tab 10" row as a single tablet.
      const uomBaseQty = rowBaseQty;
      const sellingPrice = (parseFloat(d?.item_selling_price) || 0) * uomBaseQty;
      const unitPrice = parseFloat(d?.item_unit_price) || 0;
      const allocQty = parseFloat(d?.quantity) || 0;
      const baseAmount = sellingPrice * allocQty;
      const discountAmount = parseFloat(
        ((unitPrice * uomBaseQty - sellingPrice) * allocQty).toFixed(2)
      );
      const discountPct =
        parseFloat(d?.discount_percentage ?? d?.item_discount_percentage) || 0;
      const taxAmount = parseFloat(((baseAmount * taxPct) / 100).toFixed(2));
      const totalAmount = baseAmount + taxAmount;
      return {
        item_batch_number: d?.batchNumber ?? 0,
        item_batch_quantity: allocQty,
        item_batch_avail_quantity: allocQty,
        item_batch_free_quantity: 0,
        item_batch_sales_rate: sellingPrice,
        item_batch_purhcase_rate_before_tax: sellingPrice,
        item_batch_total_base_sales_rate: parseFloat(baseAmount.toFixed(2)),
        item_batch_discount_percentage: discountPct,
        item_batch_discount_amount: discountAmount,
        item_batch_discounted_sales_rate: parseFloat(baseAmount.toFixed(2)),
        item_batch_tax_percentage: taxPct,
        item_batch_tax_amount: taxAmount,
        item_batch_final_sales_rate:
          allocQty > 0 ? parseFloat((totalAmount / allocQty).toFixed(2)) : 0,
        item_batch_total_sales_rate: parseFloat(totalAmount.toFixed(2)),
        item_exp_date: d?.expiryDate
          ? moment(d?.expiryDate).format("YYYY-MM-DD")
          : "1970-01-01",
        item_id: item?.item_id ?? 0,
        from_bin_location: d?.item_rack_location ?? "",
        from_bin_id: d?.to_bin_id ?? 0,
        item_batch_unit_price: unitPrice,
        item_batch_cgst_percentage: cgstPct,
        item_batch_sgst_percentage: sgstPct,
        item_batch_igst_percentage: igstPct,
        item_batch_cgst_amount: parseFloat(
          ((baseAmount * cgstPct) / 100).toFixed(2)
        ),
        item_batch_sgst_amount: parseFloat(
          ((baseAmount * sgstPct) / 100).toFixed(2)
        ),
        item_batch_igst_amount: parseFloat(
          ((baseAmount * igstPct) / 100).toFixed(2)
        ),
        gst_type: isInterState === true ? "Inter" : "Intra",
      };
    });
  };

  const cloneDetailsUsable = (item) =>
    isClone &&
    item?.clone_batch_details?.found &&
    !item?.clone_batch_details?.insufficient_stock;

  const buildItemRow = (item, index) => {
    if(isClone && !cloneDetailsUsable(item)){
      errorToast(item?.item_name || 'Item Not found');
    }
    const cloneBatches = cloneDetailsUsable(item)
      ? buildBatchesFromCloneDetails(item.clone_batch_details, item)
      : null;
    const cloneAggregates = cloneBatches && {
      item_discount_amount: cloneBatches.reduce((s, b) => s + (parseFloat(b.item_batch_discount_amount) || 0), 0),
      item_tax_amount: cloneBatches.reduce((s, b) => s + (parseFloat(b.item_batch_tax_amount) || 0), 0),
      item_total_tax_percentage: cloneBatches[0]?.item_batch_tax_percentage ?? 0,
      item_total_amount: cloneBatches.reduce((s, b) => s + (parseFloat(b.item_batch_total_sales_rate) || 0), 0),
      item_cgst: cloneBatches.reduce((s, b) => s + (parseFloat(b.item_batch_cgst_amount) || 0), 0),
      item_sgst: cloneBatches.reduce((s, b) => s + (parseFloat(b.item_batch_sgst_amount) || 0), 0),
      item_igst: cloneBatches.reduce((s, b) => s + (parseFloat(b.item_batch_igst_amount) || 0), 0),
    };
    return buildRawItemRow(item, index, cloneBatches, cloneAggregates);
  };

  const buildRawItemRow = (item, index, cloneBatches, cloneAggregates) => ({
    sl_no: index + 1,
    item_code: item?.item_code,
    item_generic_name: item?.item_generic_name,
    item_name: item?.item_name,
    item_hsn: item?.item_hsn,
    item_manufacturer_name: item?.item_manufacturer_name,
    item_uom: findRowUom(item)?.alt_uom ?? item?.item_uom ?? "--",
    item_to_be_delivered: item?.item_to_be_delivered ?? 0,
    quantity:
      type === "sales"
        ? 0
        : item?.item_to_be_delivered ?? item?.item_quantity,
    item_free_quantity:
      type === "sales" ? 0 : parseInt(item?.item_free_quantity),
    item_batches:
      cloneBatches ??
      (type === "sales" || isClone
        ? []
        : item?.itemBatchData?.map((batch) => ({
          item_batch_number: batch?.item_batch_number ?? 0,
          item_batch_quantity: parseInt(batch?.item_batch_quantity) || 0,
          gst_type:vendorDetails?.[0]?.gst_type,
          item_batch_free_quantity:
            parseInt(batch?.item_batch_free_quantity) || 0,
          item_batch_sales_rate:
            parseFloat(batch?.item_batch_sales_rate) || 0,
          item_batch_total_base_sales_rate:
            parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
          item_batch_discount_percentage:
            parseFloat(batch?.item_batch_discount_percentage) || 0,
          item_batch_discount_amount:
            parseFloat(batch?.item_batch_discount_amount) || 0,
          item_batch_discounted_sales_rate:
            parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
          item_batch_tax_percentage:
            parseFloat(batch?.item_batch_tax_percentage) || 0,
          item_batch_tax_amount:
            parseFloat(batch?.item_batch_tax_amount) || 0,
          item_batch_final_sales_rate:
            parseFloat(batch?.item_batch_final_sales_rate) || 0,
          item_batch_total_sales_rate:
            parseFloat(batch?.item_batch_total_sales_rate) || 0,
          item_batch_unit_price:
            parseFloat(batch?.item_batch_unit_price) || 0,
          item_batch_ptr_amount:
              parseFloat(batch?.item_batch_ptr_amount) || 0,
          item_batch_pts:
              parseFloat(batch?.item_batch_pts_amount) || 0,
          item_exp_date: batch?.item_exp_date
            ? moment(batch?.item_exp_date).format("YYYY-MM-DD")
            : "1970-01-01", // Default to a date if not provided
          item_id: batch?.item_id ?? 0,
          from_bin_location: batch?.from_bin_location ?? "",
          from_bin_id: batch?.from_bin_id ?? 0,
          item_batch_avail_quantity: parseInt(batch?.item_batch_quantity),
          item_batch_cgst_percentage:(batch?.item_batch_cgst_percentage||0),
          item_batch_sgst_percentage:(batch?.item_batch_sgst_percentage||0),
          item_batch_igst_percentage:(batch?.item_batch_igst_percentage||0),
          item_batch_cgst_amount:(batch?.item_batch_cgst_amount||0),
          item_batch_sgst_amount:(batch?.item_batch_sgst_amount||0),
          item_batch_igst_amount:(batch?.item_batch_igst_amount||0),
        })) ?? []),
    item_discount_amount: cloneAggregates
      ? cloneAggregates.item_discount_amount
      : type === "sales" || isClone ? 0 : item?.item_discount_amount,
    item_total_tax_percentage: cloneAggregates
      ? cloneAggregates.item_total_tax_percentage
      : type === "sales" || isClone ? 0 : item?.item_total_tax_percentage,
    item_tax_amount: cloneAggregates
      ? cloneAggregates.item_tax_amount
      : type === "sales" || isClone ? 0 : item?.item_tax_amount ?? 0,
    item_total_amount: cloneAggregates
      ? cloneAggregates.item_total_amount?.toFixed(2)
      : type === "sales" || isClone ? 0 : item?.item_total_amount,
    item_id: item?.item_id,
    sott_id: item?.sott_id,
    sodtt_id: item?.sodtt_id,
    base_ref_id: item?.sodtt_id ?? item?.sott_id ?? null,
    base_ref_type: item?.ref_type ?? null,
    base_ref_line_id: item?.item_id ?? null,
    base_ref_doc_number: item?.ref_doc_number ?? null,
    instock: isClone ? !!cloneBatches : true,
    item_gst: cloneAggregates ? cloneAggregates.item_total_tax_percentage : item?.item_gst,
    item_cgst: cloneAggregates ? cloneAggregates.item_cgst : item?.item_cgst,
    item_sgst: cloneAggregates ? cloneAggregates.item_sgst : item?.item_sgst,
    item_igst: cloneAggregates ? cloneAggregates.item_igst : item?.item_igst,
    uom_dropdown: item?.uom_dropdown
      ? item?.uom_dropdown.map((uom) => ({
        base_quantity: uom?.base_quantity ?? 1,

        item_uom_id: uom?.item_id,
        label: uom?.alt_uom,
        value: uom?.alt_uom,
      }))
      : [],
    // Resolved from the dropdown when the fetch omits it — the quantity cell
    // in sales-items-sec.js stays read-only while a row has no item_uom_id.
    item_uom_id: item?.item_uom_id || findRowUom(item)?.item_id || "",
    item_manufacturer_id: item?.item_manufacturer_id ?? "",
    pot_id: item?.pot_id ?? null,
    pos_id: item?.pos_id ?? vendorDetails?.[0]?.pos_id ?? itemData?.pos_id ?? null,
    base_quantity: getCloneRowBaseQuantity(item),
  });

  // Built here rather than inline in `data` below so the clone rollup can sum
  // the very same rows into the header totals.
  const initialRows =
    orderDetail?.map((item, index) => buildItemRow(item, index)) ?? [];
  const cloneHeaderTotals = isClone
    ? rollUpFooterTotals(initialRows, {
        tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type,
        tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage,
        is_invoice_dis_percentage:
          vendorDetails?.[0]?.soit_is_invoice_dis_percentage,
        header_inv_dis_per: vendorDetails?.[0]?.soit_is_invoice_dis_percentage
          ? vendorDetails?.[0]?.soit_invoice_discount_percentage
          : vendorDetails?.[0]?.soit_invoice_discount,
      })
    : null;

  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
        label: vendorDetails?.[0]?.cmr_code ?? "",
        value: vendorDetails?.[0]?.cmr_id ?? "",
      }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
        label: vendorDetails?.[0]?.cmr_name,
        value: vendorDetails?.[0]?.cmr_id,
      }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    remarks: vendorDetails?.[0]?.remarks ?? "",
    is_inter_state: isInterState,
    ...(vendorDetails?.[0]?.soit_id
      ? { soit_id: vendorDetails?.[0]?.soit_id }
      : {}),
    soit_order_date: vendorDetails?.[0]?.soit_order_date && !isClone
      ? moment(vendorDetails?.[0]?.soit_order_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    soit_document_date: vendorDetails?.[0]?.soit_document_date && !isClone
      ? moment(vendorDetails?.[0]?.soit_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    soit_delivery_date: vendorDetails?.[0]?.soit_delivery_date && !isClone
      ? moment(vendorDetails?.[0]?.soit_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    soit_reference_inv_date: vendorDetails?.[0]?.soit_reference_inv_date
      ? moment(vendorDetails?.[0]?.soit_reference_inv_date).format("YYYY-MM-DD")
      : "",
    cmr_gstin: vendorDetails?.[0]?.cmr_gstin ?? "",
    customer_invoice_number:vendorDetails?.[0]?.customer_invoice_number??null,
    // pot_id: vendorDetails?.[0]?.pot_id ?? null,
    // pos_id: vendorDetails?.[0]?.pos_id ?? null,
    pot_id: vendorDetails?.[0]?.pot_id ?? itemData?.pot_id ?? null,
    pos_id: vendorDetails?.[0]?.pos_id ?? itemData?.pos_id ?? null,

    soit_sub_total: cloneHeaderTotals
      ? cloneHeaderTotals.sub_total
      : vendorDetails?.[0]?.soit_sub_total || "0.00",
    soit_total_discount: cloneHeaderTotals
      ? cloneHeaderTotals.total_discount
      : vendorDetails?.[0]?.soit_total_discount ?? 0,
    soit_total_gst: cloneHeaderTotals
      ? cloneHeaderTotals.total_gst
      : vendorDetails?.[0]?.soit_total_gst || "0.00",
    soit_round_off_value: cloneHeaderTotals
      ? cloneHeaderTotals.round_off_value
      : vendorDetails?.[0]?.soit_round_off_value || "0.00",
    soit_total_amount: cloneHeaderTotals
      ? cloneHeaderTotals.total_amount
      : vendorDetails?.[0]?.soit_total_amount || "0.00",
    cmr_tcs: "",
    cmr_tds: "",
    soit_tcs_or_tds_percentage_id:
      vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
    soit_tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage ?? 0,
    soit_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
    soit_tcs_or_tds_amount: cloneHeaderTotals
      ? cloneHeaderTotals.tcs_or_tds_amount
      : vendorDetails?.[0]?.tcs_or_tds_amount ?? 0,
    soit_order_status: vendorDetails?.[0]?.soit_order_status ?? "",
    soit_pay_to_address: payto || null, //new
    soit_ship_to_address: shipto || null, //new

    soit_custom_invoice_number: vendorDetails?.[0]?.soit_custom_invoice_number ?? null,
    soit_is_invoice_dis_percentage:
      vendorDetails?.[0]?.soit_is_invoice_dis_percentage ?? true,
    soit_invoice_discount: cloneHeaderTotals
      ? cloneHeaderTotals.invoice_discount
      : vendorDetails?.[0]?.soit_invoice_discount ?? 0,
    soit_invoice_discount_percentage: cloneHeaderTotals
      ? cloneHeaderTotals.invoice_discount_percentage
      : vendorDetails?.[0]?.soit_invoice_discount_percentage ?? 0,
    header_dis_per: "",
    header_inv_dis_per: vendorDetails?.[0]?.soit_is_invoice_dis_percentage
      ? vendorDetails?.[0]?.soit_invoice_discount_percentage
      : vendorDetails?.[0]?.soit_invoice_discount,

    data: [
      ...initialRows,
      initialData,
      // ...(type === "sales" || type === "invoice"
      //   ? [{ ...initialData }]
      //   : []),
    ],
  };

  const [initialValue, setInitialValue] = useState(initialFormValues);
  const setFieldValueRef = useRef(null);
  const valuesRef = useRef(null);
  const orderDetailMountedRef = useRef(false);
  const syncedItemCountRef = useRef(orderDetail?.length ?? 0);
  // On the paginated "view" page (and the paginated clone-into-add flow), new
  // batches of items arrive into `orderDetail` after the form has already
  // mounted (and Formik's initialValues are frozen). Only transform + append
  // the newly-arrived items into the live form values — re-deriving/replacing
  // the whole `data` array on every batch would re-render every already-
  // rendered row (and their react-select controls), which is what was
  // causing the scroll stutter.
  useEffect(() => {
    if (page !== "view" && !isClone) return;
    if (!orderDetailMountedRef.current) {
      orderDetailMountedRef.current = true;
      syncedItemCountRef.current = orderDetail?.length ?? 0;
      return;
    }
    const newRawItems = (orderDetail ?? []).slice(syncedItemCountRef.current);
    if (!newRawItems.length) return;
    const newRows = newRawItems.map((item, i) =>
      buildItemRow(item, syncedItemCountRef.current + i)
    );
    syncedItemCountRef.current = orderDetail.length;

    const currentData = valuesRef.current?.data ?? [];
    const blankRow = currentData[currentData.length - 1];
    const existingRows = currentData.slice(0, -1);
    const mergedRows = [...existingRows, ...newRows];
    setFieldValueRef.current?.("data", [...mergedRows, blankRow]);

    // The clone header totals were rolled up from the first frame only, so
    // grow them as later frames land.
    if (isClone) {
      const totals = rollUpFooterTotals(mergedRows, {
        tds_tcs_type: valuesRef.current?.soit_tds_tcs_type,
        tcs_or_tds_percentage: valuesRef.current?.soit_tcs_or_tds_percentage,
        is_invoice_dis_percentage:
          valuesRef.current?.soit_is_invoice_dis_percentage,
        header_inv_dis_per: valuesRef.current?.header_inv_dis_per,
      });
      setFieldValueRef.current?.("soit_sub_total", totals.sub_total);
      setFieldValueRef.current?.("soit_total_gst", totals.total_gst);
      setFieldValueRef.current?.("soit_total_discount", totals.total_discount);
      setFieldValueRef.current?.(
        "soit_tcs_or_tds_amount",
        totals.tcs_or_tds_amount
      );
      setFieldValueRef.current?.(
        "soit_invoice_discount",
        totals.invoice_discount
      );
      setFieldValueRef.current?.(
        "soit_invoice_discount_percentage",
        totals.invoice_discount_percentage
      );
      setFieldValueRef.current?.("soit_total_amount", totals.total_amount);
      setFieldValueRef.current?.(
        "soit_round_off_value",
        totals.round_off_value
      );
    }
  }, [orderDetail]);
  // When cloning, tell the user which items couldn't bring their batches over
  // (not found, or not enough stock) so they add them manually. Only in the
  // clone flow, and once per item: this used to run inside buildItemRow, i.e.
  // during render, so it fired on View/Edit/Add too (cloneDetailsUsable is
  // always false outside a clone) and repeated on every re-render.
  const cloneWarnedRef = useRef(new Set());
  useEffect(() => {
    if (!isClone) return;
    (orderDetail ?? []).forEach((item, index) => {
      if (cloneDetailsUsable(item)) return;
      const key = item?.item_id ?? `${item?.item_name}-${index}`;
      if (cloneWarnedRef.current.has(key)) return;
      cloneWarnedRef.current.add(key);
      const name = item?.item_name || "Item";
      errorToast(
        item?.clone_batch_details?.insufficient_stock
          ? `${name}: not enough stock to clone - add batches manually`
          : `${name}: batch details not found to clone - add batches manually`
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail, isClone]);
  const [reload, setReload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code number is required"),
    cmr_name: Yup.object().required("Customer name is required"),
  });
  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const salesData = parsed.find((obj) => obj?.sales_invoice_create);
      if (salesData?.sales_invoice_create) {
        const cols = [...salesData.sales_invoice_create];
        if (!cols.some((c) => c.value === "item_pack_size")) {
          const qtyIdx = cols.findIndex((c) => c.value === "quantity");
          const insertAt = qtyIdx !== -1 ? qtyIdx + 1 : cols.length;
          cols.splice(insertAt, 0, {
            label: "Unit Qty",
            value: "item_pack_size",
            minWidth: 80,
            alignment: "right",
          });
        }
        setHeading(cols);
      }
    }
  }, []);
  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => { };
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    const storeData=data?.data;
    const storeState=storeData?.store_state;
    const store_state=storeState?.toLowerCase()?.trim();
    if(store_state===null || store_state===undefined || store_state?.trim()===""){
        errorToast("Please configure store state in store deatils")
        return;
    }
  };
  const onErrorStoreDetails = () => { };

  const handleSubmit = (values, actions) => {
    // Block duplicate submissions while a request is already in flight.
    if (isDispatchingRef.current) return;
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (!values?.soit_pay_to_address) {
      errorToast("Please verify and save the address");
      return;
    }
    if (!values?.soit_ship_to_address) {
      errorToast("Please verify and save the address");
      return;
    }
    if(!values?.soit_custom_invoice_number || values?.soit_custom_invoice_number?.trim()==="" ||values?.soit_custom_invoice_number===""){
      errorToast("Please check custom invoice number");
      return;
    }
    if (
      page === "edit"
      // &&
      // values?.submittedButton !== "draft" 
      //&& values?.soit_order_status !== "draft"
    ) {
      isDispatchingRef.current = true;
      setButtonLoading(true);
      const data = {
        orderData: {
          is_draft_order:
            values.submittedButton === "draft" ? true : false,
          store_id: storeId,
          ...(values?.soit_id ? { soit_id: values?.soit_id } : {}),
          soit_total_gst: values?.soit_total_gst,
          soit_total_discount: values?.soit_total_discount,
          soit_payment_status: "paid",
          soit_transaction_id: "",
          soit_billing_address: "",
          soit_total_amount: values?.soit_total_amount,
          soit_sub_total: values?.soit_sub_total,
          cmr_code: values?.cmr_code?.label,
          cmr_id: values?.cmr_id,
          cmr_name: values?.cmr_name?.label,
          remarks: values?.remarks,
          soit_order_date: values?.soit_order_date,
          soit_custom_invoice_number: values?.soit_custom_invoice_number,
          soit_document_date: values?.soit_document_date,
          soit_delivery_date: values?.soit_delivery_date,
          soit_reference_inv_date: values?.soit_reference_inv_date|| null,
          cmr_gstin: values?.cmr_gstin || null,
          pot_id: values?.pot_id ?? null,
          pos_id: values?.pos_id ??values?.soit_ship_to_address?.store_id ?? null,
          soit_round_off_value: values?.soit_round_off_value,

          soit_tcs_or_tds_percentage_id:
            values?.soit_tcs_or_tds_percentage_id ?? "",
          soit_tcs_or_tds_percentage:
            Number(values?.soit_tcs_or_tds_percentage) ?? 0,
          soit_tds_tcs_type: values?.soit_tds_tcs_type ?? "",
          soit_tcs_or_tds_amount: values?.soit_tcs_or_tds_amount ?? 0,
          customer_invoice_number: values?.customer_invoice_number, // not accepting in backend
          soit_is_invoice_dis_percentage: Number(
            values?.soit_is_invoice_dis_percentage
          ),
          soit_invoice_discount: Number(values?.soit_invoice_discount),
          soit_invoice_discount_percentage: Number(
            values?.soit_invoice_discount_percentage
          ),
          soit_pay_to_address: values?.soit_pay_to_address || null, //new
          soit_ship_to_address: values?.soit_ship_to_address || null, //new
          gst_type:values?.is_inter_state===false?"Intra":"Inter"
        },
        itemData: values.data?.slice(0, -1).map((item, index) => ({
          item_code: item?.item_code,
          item_generic_name: item?.item_generic_name,
          ...(values?.soit_id ? { soit_id: values?.soit_id } : {}),
          item_name: item?.item_name,
          item_hsn: item?.item_hsn,
          item_quantity: parseInt(item?.quantity),
          item_free_quantity: parseInt(item?.item_free_quantity ?? 0),
          item_batch_number: item?.item_batch_number,
          item_schedule: item?.item_schedule,
          // item_unit_price: parseFloat(item?.item_unit_price),
          item_discount_amount: parseFloat(item?.item_discount_amount),
          item_total_tax_percentage: item?.item_total_tax_percentage,
          item_tax_amount: parseFloat(item?.item_tax_amount),
          item_total_amount: parseFloat(item.item_total_amount),
          item_id: item?.item_id,
          ...(item?.sott_id && type === "sales"
            ? { sott_id: item?.sott_id }
            : { sott_id: null }),
          ...(item?.sodtt_id && type === "delivery"
            ? { sodtt_id: item?.sodtt_id }
            : { sodtt_id: null }),
          base_ref_id: item?.base_ref_id ?? null,
          base_ref_type: item?.base_ref_type ?? null,
          base_ref_line_id: item?.base_ref_line_id ?? null,
          base_ref_doc_number: item?.base_ref_doc_number ?? null,
          item_gst: parseFloat(item?.item_gst||0),
          item_sgst: values?.is_inter_state===false?parseFloat(item?.item_sgst||0):0,
          item_cgst: values?.is_inter_state===false?parseFloat(item?.item_cgst||0):0,
          item_igst: values?.is_inter_state===true?parseFloat(item?.item_igst||0):0,
          item_uom_id: item?.item_uom_id ?? "",
          item_uom: item?.item_uom ?? "",
          item_manufacturer_id: item?.item_manufacturer_id ?? "",
          item_manufacturer_name: item?.item_manufacturer_name ?? "",
          pot_id: item?.pot_id ?? null,
          pos_id: item?.pos_id ?? values?.pos_id ?? values?.soit_ship_to_address?.store_id ?? null,
        })),
        itemBatchData: values.data
          ?.slice(0, -1)
          .map((item) => item.item_batches)
          .flat()
          .map((batch) => ({
            item_batch_number: batch?.item_batch_number,
            ...(values?.soit_id ? { soit_id: values?.soit_id } : {}),
            item_batch_quantity: parseInt(batch?.item_batch_quantity),
            item_batch_free_quantity: parseInt(
              batch?.item_batch_free_quantity
            ),
            item_batch_sales_rate: parseFloat(
              batch?.item_batch_sales_rate
            ),
            item_batch_total_base_sales_rate:
              parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
            item_batch_discount_percentage:
              batch?.item_batch_discount_percentage,
            item_batch_discount_amount: parseFloat(
              batch?.item_batch_discount_amount
            ),
            item_batch_discounted_sales_rate:
              parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
            item_batch_tax_percentage: batch?.item_batch_tax_percentage,
            item_batch_ptr_amount:
              parseFloat(batch?.item_batch_ptr_amount) || 0,
            item_batch_pts_amount:
              parseFloat(batch?.item_batch_pts) || 0,
            item_batch_tax_amount: parseFloat(
              batch?.item_batch_tax_amount
            ),
            item_batch_final_sales_rate: parseFloat(
              batch?.item_batch_final_sales_rate
            ),
            item_batch_total_sales_rate: parseFloat(
              batch?.item_batch_total_sales_rate
            ),
            item_batch_unit_price: parseFloat(
              batch?.item_batch_unit_price
            ),
            item_exp_date: batch?.item_exp_date,
            item_id: batch?.item_id,
            from_bin_location: batch?.from_bin_location,
            from_bin_id: batch?.from_bin_id,
            item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
            item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
            item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
            item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
            item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
            item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
          })),
      }
      dispatch(
        salesInvoiceEditAction(
          // {
          //   is_draft_order: values.submittedButton === "draft" ? true : false,
          //   only_remarks: true,
          //   soit_id: values?.soit_id,
          //   remarks: values?.remarks,
          // },
          data,
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast(
          "Please add UOM for all items" && values?.submittedButton !== "draft"
        );
      } else {
        if (values?.data?.length > 0) {
          isDispatchingRef.current = true;
          setButtonLoading(true);

          dispatch(
            salesInvoiceReceiptCreateAction(
              {
                orderData: {
                  is_draft_order:
                    values.submittedButton === "draft" ? true : false,
                  store_id: storeId,
                  ...(values?.soit_id ? { soit_id: values?.soit_id } : {}),
                  soit_total_gst: values?.soit_total_gst,
                  soit_total_discount: values?.soit_total_discount,
                  soit_payment_status: "paid",
                  soit_transaction_id: "",
                  soit_billing_address: "",
                  soit_total_amount: values?.soit_total_amount,
                  soit_sub_total: values?.soit_sub_total,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  soit_order_date: values?.soit_order_date,
                  soit_custom_invoice_number: values?.soit_custom_invoice_number,
                  soit_document_date: values?.soit_document_date,
                  soit_delivery_date: values?.soit_delivery_date,
                  soit_reference_inv_date: values?.soit_reference_inv_date|| null,
                  cmr_gstin: values?.cmr_gstin || null,
                  pot_id: values?.pot_id ?? null,
                  pos_id: values?.pos_id ?? values?.soit_ship_to_address?.store_id  ??null,
                  soit_round_off_value: values?.soit_round_off_value,

                  soit_tcs_or_tds_percentage_id:
                    values?.soit_tcs_or_tds_percentage_id ?? "",
                  soit_tcs_or_tds_percentage:
                    Number(values?.soit_tcs_or_tds_percentage) ?? 0,
                  soit_tds_tcs_type: values?.soit_tds_tcs_type ?? "",
                  soit_tcs_or_tds_amount: values?.soit_tcs_or_tds_amount ?? 0,
                  customer_invoice_number: values?.customer_invoice_number, // not accepting in backend
                  soit_is_invoice_dis_percentage: Number(
                    values?.soit_is_invoice_dis_percentage
                  ),
                  soit_invoice_discount: Number(values?.soit_invoice_discount),
                  soit_invoice_discount_percentage: Number(
                    values?.soit_invoice_discount_percentage
                  ),
                  soit_pay_to_address: values?.soit_pay_to_address || null, //new
                  soit_ship_to_address: values?.soit_ship_to_address || null, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter"
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_quantity: parseInt(item?.quantity),
                  item_free_quantity: parseInt(item?.item_free_quantity ?? 0),
                  item_batch_number: item?.item_batch_number,
                  item_schedule: item?.item_schedule,
                  // item_unit_price: parseFloat(item?.item_unit_price),
                  item_discount_amount: parseFloat(item?.item_discount_amount),
                  item_total_tax_percentage: item?.item_total_tax_percentage,
                  item_tax_amount: parseFloat(item?.item_tax_amount),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_id: item?.item_id,
                  ...(item?.sott_id && type === "sales"
                    ? { sott_id: item?.sott_id }
                    : { sott_id: null }),
                  ...(item?.sodtt_id && type === "delivery"
                    ? { sodtt_id: item?.sodtt_id }
                    : { sodtt_id: null }),
                  base_ref_id: item?.base_ref_id ?? null,
                  base_ref_type: item?.base_ref_type ?? null,
                  base_ref_line_id: item?.base_ref_line_id ?? null,
                  base_ref_doc_number: item?.base_ref_doc_number ?? null,
                  item_gst: parseFloat(item?.item_gst||0),
                  item_sgst: values?.is_inter_state===false?parseFloat(item?.item_sgst||0):0,
                  item_cgst: values?.is_inter_state===false?parseFloat(item?.item_cgst||0):0,
                  item_igst: values?.is_inter_state===true?parseFloat(item?.item_igst||0):0,
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  pot_id: item?.pot_id ?? null,
                  pos_id: item?.pos_id ?? values?.pos_id ?? values?.soit_ship_to_address?.store_id  ?? null,
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_batch_quantity: parseInt(batch?.item_batch_quantity),
                    item_batch_free_quantity: parseInt(
                      batch?.item_batch_free_quantity
                    ),
                    item_batch_sales_rate: parseFloat(
                      batch?.item_batch_sales_rate
                    ),
                    item_batch_total_base_sales_rate:
                      parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                    item_batch_discount_percentage:
                      batch?.item_batch_discount_percentage,
                    item_batch_discount_amount: parseFloat(
                      batch?.item_batch_discount_amount
                    ),
                    item_batch_discounted_sales_rate:
                      parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                    item_batch_tax_percentage: batch?.item_batch_tax_percentage,
                    item_batch_tax_amount: parseFloat(
                      batch?.item_batch_tax_amount
                    ),
                    item_batch_final_sales_rate: parseFloat(
                      batch?.item_batch_final_sales_rate
                    ),
                    item_batch_total_sales_rate: parseFloat(
                      batch?.item_batch_total_sales_rate
                    ),
                    item_batch_unit_price: parseFloat(
                      batch?.item_batch_unit_price
                    ),
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    from_bin_id: batch?.from_bin_id,
                    item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
                    item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
                    item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
                    item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
                    item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
                    item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
                    item_batch_ptr_amount:
                      parseFloat(batch?.item_batch_ptr_amount) || 0,
                    item_batch_pts_amount:
                      parseFloat(batch?.item_batch_pts) || 0,
                  })),
              },
              onSuccessOrder,
              onErrorOrder
            )
          );
        }
      }
    }
  };

  const onSuccessOrder = (data) => {
    isDispatchingRef.current = false;
    setButtonLoading(false);

    if (formValues?.submittedButton === "print") {
      handlea4Print(data?.data?.orderData?.soit_id, "sales_invoice", dispatch);
    }
    navigate("/sales-invoice");
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      cmr_id: "",
      remarks: "",
      soit_total_discount: 0,
      soit_order_date: null,
      soit_document_date: null,
      soit_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = () => {
    errorToast(data?.data?.message);
    isDispatchingRef.current = false;
    setButtonLoading(false);
  };

  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  const autoDraft = (values) => {
    if (isDispatchingRef.current) return;
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.soit_order_status !== "draft"
    ) {
      isDispatchingRef.current = true;
      setButtonLoading(true);

      dispatch(
        salesInvoiceEditAction(
          {
            is_draft_order: values.submittedButton === "draft" ? true : false,
            only_remarks: true,
            soit_id: values?.soit_id,
            remarks: values?.remarks,
          },
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast(
          "Please add UOM for all items" && values?.submittedButton !== "draft"
        );
      } else {
        const hasItems = (values?.data?.length ?? 0) > 1;
        if (hasItems) {
          isDispatchingRef.current = true;
          setButtonLoading(true);

          dispatch(
            salesInvoiceReceiptCreateAction(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: storeId,
                  ...(values?.soit ? { soit: values?.soit } : {}),
                  soit_total_gst: values?.soit_total_gst,
                  soit_total_discount: values?.soit_total_discount,
                  soit_payment_status: "paid",
                  soit_transaction_id: "",
                  soit_billing_address: "",
                  soit_total_amount: values?.soit_total_amount,
                  soit_sub_total: values?.soit_sub_total,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  soit_order_date: values?.soit_order_date,
                  soit_custom_invoice_number: values?.soit_custom_invoice_number,
                  soit_document_date: values?.soit_document_date,
                  soit_delivery_date: values?.soit_delivery_date,
                  soit_reference_inv_date: values?.soit_reference_inv_date|| null,
                  cmr_gstin: values?.cmr_gstin || null,
                  pot_id: values?.pot_id ?? null,
                  pos_id: values?.pos_id ?? values?.soit_ship_to_address?.store_id  ?? null,
                  soit_round_off_value: values?.soit_round_off_value,

                  soit_tcs_or_tds_percentage_id:
                    values?.soit_tcs_or_tds_percentage_id ?? "",
                  soit_tcs_or_tds_percentage:
                    Number(values?.soit_tcs_or_tds_percentage) ?? 0,
                  soit_tds_tcs_type: values?.soit_tds_tcs_type ?? "",
                  soit_tcs_or_tds_amount: values?.soit_tcs_or_tds_amount ?? 0,
                  customer_invoice_number: values?.customer_invoice_number, // not accepting in backend
                  soit_is_invoice_dis_percentage: Number(
                    values?.soit_is_invoice_dis_percentage
                  ),
                  soit_invoice_discount: Number(values?.soit_invoice_discount),
                  soit_invoice_discount_percentage: Number(
                    values?.soit_invoice_discount_percentage
                  ),
                  soit_pay_to_address: values?.soit_pay_to_address || null, //new
                  soit_ship_to_address: values?.soit_ship_to_address || null, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter"
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_quantity: parseInt(item?.quantity),
                  item_free_quantity: parseInt(item?.item_free_quantity ?? 0),
                  item_batch_number: item?.item_batch_number,
                  item_schedule: item?.item_schedule,
                  // item_unit_price: parseFloat(item?.item_unit_price),
                  item_discount_amount: parseFloat(item?.item_discount_amount),
                  item_total_tax_percentage: item?.item_total_tax_percentage,
                  item_tax_amount: parseFloat(item?.item_tax_amount),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_id: item?.item_id,
                  ...(item?.sott_id && type === "sales"
                    ? { sott_id: item?.sott_id }
                    : { sott_id: null }),
                  ...(item?.sodtt_id && type === "delivery"
                    ? { sodtt_id: item?.sodtt_id }
                    : { sodtt_id: null }),
                  base_ref_id: item?.base_ref_id ?? null,
                  base_ref_type: item?.base_ref_type ?? null,
                  base_ref_line_id: item?.base_ref_line_id ?? null,
                  base_ref_doc_number: item?.base_ref_doc_number ?? null,
                  item_gst: parseFloat(item?.item_gst||0),
                  item_sgst: values?.is_inter_state===false?parseFloat(item?.item_sgst||0):0,
                  item_cgst: values?.is_inter_state===false?parseFloat(item?.item_cgst||0):0,
                  item_igst: values?.is_inter_state===true?parseFloat(item?.item_igst||0):0,
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  pot_id: item?.pot_id ?? null,
                  pos_id: item?.pos_id ?? values?.pos_id ?? values?.soit_ship_to_address?.store_id  ?? null,
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_batch_quantity: parseInt(batch?.item_batch_quantity),
                    item_batch_free_quantity: parseInt(
                      batch?.item_batch_free_quantity
                    ),
                    item_batch_sales_rate: parseFloat(
                      batch?.item_batch_sales_rate
                    ),
                    item_batch_total_base_sales_rate:
                      parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                    item_batch_discount_percentage:
                      batch?.item_batch_discount_percentage,
                    item_batch_discount_amount: parseFloat(
                      batch?.item_batch_discount_amount
                    ),
                    item_batch_discounted_sales_rate:
                      parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                    item_batch_tax_percentage: batch?.item_batch_tax_percentage,
                    item_batch_tax_amount: parseFloat(
                      batch?.item_batch_tax_amount
                    ),
                    item_batch_final_sales_rate: parseFloat(
                      batch?.item_batch_final_sales_rate
                    ),
                    item_batch_total_sales_rate: parseFloat(
                      batch?.item_batch_total_sales_rate
                    ),
                    item_batch_unit_price: parseFloat(
                      batch?.item_batch_unit_price
                    ),
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    from_bin_id: batch?.from_bin_id,
                    item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
                    item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
                    item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
                    item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
                    item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
                    item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
                  })),
              },
              (data) => {
                successToast(data?.message);
                // setLoading(true);
                setTimeout(() => {
                  // setLoading(false);
                }, 50);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-sales-invoice/${data?.data?.orderData?.soit_id}?new`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                errorToast(data?.data?.message);
              }
            )
          );
        } else {
          navigate(
            `/edit-customer-admin/${values?.cmr_id}?backto=/add-sales-invoice/%255B%255D/invoice?new`,
            {
              state: { tab: "Address" },
            }
          );
        }
      }
    }
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        if (submitScheduledRef.current || isDispatchingRef.current) {
          actions.setSubmitting(false);
          return;
        }
        submitScheduledRef.current = true;
        setButtonLoading(true);
        setTimeout(() => {
          submitScheduledRef.current = false;
          handleSubmit(values, actions); // arms isDispatchingRef on dispatch
          if (!isDispatchingRef.current) {
            setButtonLoading(false);
          }
          actions.setSubmitting(false); // Notify Formik that submission is done
        }, 500);
      }}
    >
      {({ values, setFieldValue, errors }) => {
        setFormValues(values);
        setFieldValueRef.current = setFieldValue;
        valuesRef.current = values;
        return (
          <Form className="h-full">
            <div
              style={{
                height: `calc(100% - 8rem)`,
              }}
              className="mx-5 flex flex-col h-full "
            >
              <SalesBatchesPanel
                searchRef={searchRef}
                open={addbatch}
                setOpen={setAddbatch}
                disabled={disabled}
                setItemId={setItemId}
                itemId={itemId}
                itemValues={values}
                prefix="soit"
              />
              <SalesPurchaseNavbar
                isClone={isClone}
                autoDraft={autoDraft}
                clickedplus={clickedplus}
                pageType={pageType}
                page={page}
                section="sales"
                name="soit"
                disabled={disabled}
                searchRef={searchRef}
                storeDetails={storeDetails}
                transfer={transfer}
                standAlone={standAlone}
              />

              <SalesItemsSection
                isClone={isClone}
                auto={auto}
                clickedplus={clickedplus}
                heading={heading}
                standAlone={standAlone}
                disName="soit_total_discount"
                type={type}
                disabled={values.is_inter_state===null || disabled}
                addBatchFn={(id) => {
                  setAddbatch(true);
                  setItemId(id);
                }}
                searchRef={searchRef}
                initialData={initialData}
                prefixName={"soit"}
                isNotViewOnly={isNotViewOnly}
                itemValues={values}
                itemsLoading={itemsLoading}
                onItemsScroll={onItemsScroll}
              />
            </div>
            <SalesPurchaseFooter
              modules="sales"
              EditFn={() => {
                navigate(`/edit-sales-invoice/${values?.soit_id}`);
              }}
              transaction="Sales Invoice"
              transaction_type="sales_invoice"
              buttonLoading={buttonLoading}
              name="soit_total_discount"
              page={page}
              disabled={disabled}
              prefixName="soit"
              tcsTdsAmount={tcsTdsAmount}
              setTcsTdsAmount={setTcsTdsAmount}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEditViewSalesInv;
